<template>
  <DxScrollView :use-native="true" class="stock_wrapper">
    <div class="stock_list_holder">
      <div v-for="(product, r_idx) in selectedProductList" :key="r_idx">
        <div class="stock_item">
          <div class="stock_main_info">
            <div class="product_name">
              {{
                product.code
                  ? `${product.name} (${product.code})`
                  : product.name
              }}
            </div>
            <div class="product_type">
              {{ product.product_type ? product.product_type.name : $t("stock_mobile.form.others") }}
            </div>
          </div>
          <div class="stock_quantity">
            {{ (product.quantity ?? 0) | getFormattedQuantity }}
            {{ product?.measure_unit?.symbol }}
          </div>
          <div class="expand_icon_holder">
            <div :class="product.expanded !== false ? 'expand_icon_expanded' : 'expand_icon'"
              @click="expandProduct(product, r_idx)">
              <img v-show="product.expanded !== false" src="@/assets/images/icons/arrow_up_green.svg" />
              <img v-show="product.expanded === false" src="@/assets/images/icons/arrow_down.svg" />
            </div>
          </div>
        </div>
        <div class="stock_details_holder" v-show="product.expanded !== false">
          <div class="stock_details_spacer"></div>
          <div class="info_line" v-show="selectFromStock">
            <div class="info_value">{{ $t("common.warehouse") }}:</div>
            <div class="info_quantity">
              {{ product.warehouse_name }}<template v-if="product.department_name"> ({{ product.department_name }})</template>
            </div>
          </div>
          <div class="info_line" v-if="product.dest_warehouse_name">
            <div class="info_value">{{ $t("stock_mobile.form.receiver_warehouse") }}:</div>
            <div class="info_quantity">
              {{ product.dest_warehouse_name }}<template v-if="product.dest_department_name"> ({{ product.dest_department_name }})</template>
            </div>
          </div>
          <div class="info_line">
            <div class="info_value">{{ $t("common.quantity") }}:</div>
            <div class="info_quantity">
              {{ (product.quantity ?? 0) | getFormattedQuantity }}
            </div>
          </div>
          <div class="info_line">
            <div class="info_value">{{ $t("common.measure_unit") }}:</div>
            <div class="info_quantity">
              {{ product?.measure_unit?.symbol }}
            </div>
          </div>
          <div class="info_line" v-show="!selectFromStock">
            <div class="info_value">{{ $t("stock_mobile.form.unit_price_label") }}:</div>
            <div class="info_quantity">
              {{ product?.unit_price }}
            </div>
          </div>
          <div class="info_line">
            <div class="info_value">{{ $t("common.notes") }}:</div>
            <div class="info_quantity">
              {{ product?.notes }}
            </div>
          </div>
          <div class="info_line">
            <div class="info_value"><i class="fa fa-edit selected_product_action_icon"
                @click="editProductData(product.uuid)"></i></div>
            <div class="info_quantity"></div>
            <i v-if="isProductEditable" class="fa fa-trash selected_product_action_icon" @click="removeFromSelectedList(r_idx)"></i>
          </div>
        </div>
      </div>
      <div style="height: 40px"></div>
    </div>
    <div style="margin-bottom: 50px;" class="sticky_action_button" @click="closeSelector">
      {{ $t("common.continue") }}
    </div>
  </DxScrollView>
</template>

<script>
import { DxScrollView } from "devextreme-vue/scroll-view";

export default {
  name: "SelectedProductList",
  props: {
    selectedProductList: {
      type: Array,
      default: () => [],
    },
    selectFromStock: {
      type: Boolean,
      default: false,
    },
    isProductEditable: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },
  components: {
    DxScrollView,
  },
  methods: {
    expandProduct(product, idx) {
      product.expanded = !product.expanded;
      this.$set(this.selectedProductList, idx, product);
    },
    closeSelector() {
      this.$emit("closeProductSelector");
    },
    editProductData(productUuid) {
      this.$emit("editProductData", productUuid);
    },
    removeFromSelectedList(r_idx) {
      this.selectedProductList.splice(r_idx, 1);
    },
  },
};
</script>

<style>
.fa-trash {
  color: red;
}

.selected_product_action_icon {
  font-size: 18px;
  padding: 10px;
}
</style>